import { ActionWithPayload, createAction } from 'helpers/redux-actions.helper'
import { ActionsUnion } from 'helpers/types.helper'
import { ICourseModel } from 'models/course.model'
import { IAssignedLessonModel } from 'models/assignedLesson.model'
import { IFolderModel } from 'models/folder.model'
import { IndividualFilters } from 'api/courses/exportReport'

export const COURSES_ADMINISTRATION_GET_LIST = 'COURSES_ADMINISTRATION_GET_LIST'
export const COURSES_ADMINISTRATION_GET_LIST_SUCCESS =
  'COURSES_ADMINISTRATION_GET_LIST_SUCCESS'
export const CREATE_COURSE = 'CREATE_COURSE'
export const GET_COURSE = 'GET_COURSE'
export const GET_COURSE_AND_CREATE_ENROL = 'GET_COURSE_AND_CREATE_ENROL'
export const GET_COURSE_SUCCESS = 'GET_COURSE_SUCCESS'
export const SET_COURSE_LOADING = 'SET_COURSE_LOADING'
export const EDIT_COURSE = 'EDIT_COURSE'
export const EDIT_COURSE_SUCCESS = 'EDIT_COURSE_SUCCESS'
export const DESTROY_COURSE = 'DESTROY_COURSE'
export const COURSES_USER_GET_ALL_LIST = 'COURSES_USER_GET_ALL_LIST'
export const COURSES_USER_GET_ALL_LIST_SUCCESS =
  'COURSES_USER_GET_ALL_LIST_SUCCESS'
export const COURSES_USER_GET_MY_LIST = 'COURSES_USER_GET_MY_LIST'
export const COURSES_USER_GET_MANDATORY_LIST = 'COURSES_USER_GET_MANDATORY_LIST'
export const COURSES_USER_GET_MANDATORY_LIST_SUCCESS =
  'COURSES_USER_GET_MANDATORY_LIST_SUCCESS'
export const COURSES_USER_GET_MY_LIST_SUCCESS =
  'COURSES_USER_GET_MY_LIST_SUCCESS'
export const COURSES_USER_COURSE_PROGRESS = 'COURSES_USER_COURSE_PROGRESS'
export const COURSES_USER_COURSE_PROGRESS_SUCCESS =
  'COURSES_USER_COURSE_PROGRESS_SUCCESS'
export const PUBLISH_COURSE = 'PUBLISH_COURSE'
export const COURSES_DOWNLOAD = 'COURSES_DOWNLOAD'
export const COURSES_DOWNLOAD_SUCCESS = 'COURSES_DOWNLOAD_SUCCESS'
export const COURSES_DOWNLOAD_EVALUATIONS = 'COURSES_DOWNLOAD_EVALUATIONS'
export const COURSES_DOWNLOAD_EVALUATIONS_SUCCESS =
  'COURSES_DOWNLOAD_EVALUATIONS_SUCCESS'
export const COURSES_DOWNLOAD_DISABLED_USERS = 'COURSES_DOWNLOAD_DISABLED_USERS'
export const COURSES_DOWNLOAD_DISABLED_USERS_UPDATE =
  'COURSES_DOWNLOAD_DISABLED_USERS_UPDATE'
export const CLEAR_COURSES_DOWNLOAD = 'CLEAR_COURSES_DOWNLOAD'
export const COURSES_REPORT = 'COURSES_REPORT'
export const COURSES_REPORT_SUCCESS = 'COURSES_REPORT_SUCCESS'
export const GET_ADMIN_COURSE = 'GET_ADMIN_COURSE'
export const COURSES_INDIVIDUAL_DOWNLOAD = 'COURSES_INDIVIDUAL_DOWNLOAD'
export const COURSES_BASIC_REPORT_DOWNLOAD = 'COURSES_BASIC_REPORT_DOWNLOAD'
export const COURSES_INDIVIDUAL_DOWNLOAD_SUCCESS =
  'COURSES_INDIVIDUAL_DOWNLOAD_SUCCESS'

export const GET_COURSE_DATA_TO_DUPLICATE = 'GET_COURSE_DATA_TO_DUPLICATE'
export const GET_COURSE_DATA_TO_DUPLICATE_SUCCESS =
  'GET_COURSE_DATA_TO_DUPLICATE_SUCCESS'
export const COURSE_DUPLICATE = 'COURSE_DUPLICATE'

export const COURSES_GET_NAME_LIST = 'COURSES_GET_NAME_LIST'
export const COURSES_GET_NAME_LIST_SUCCESS = 'COURSES_GET_NAME_LIST_SUCCESS'

export const COURSES_GET_COUNTERS = 'COURSES_GET_COUNTERS'
export const COURSES_GET_COUNTERS_SUCCESS = 'COURSES_GET_COUNTERS_SUCCESS'

export const COURSES_CLEAR_HOME_LISTS = 'COURSES_CLEAR_HOME_LISTS'

export const COURSES_GET_MY_FOLDERS = 'COURSES_GET_MY_FOLDERS'
export const COURSES_GET_MY_FOLDERS_SUCCESS = 'COURSES_GET_MY_FOLDERS_SUCCESS'

export const COURSES_GET_ALL_FOLDERS = 'COURSES_GET_ALL_FOLDERS'
export const COURSES_GET_ALL_FOLDERS_SUCCESS = 'COURSES_GET_ALL_FOLDERS_SUCCESS'

export const COURSES_SET_EMAIL_NOTIFICATION = 'COURSES_SET_EMAIL_NOTIFICATION'
export const COURSES_SET_SECTION = 'COURSES_SET_SECTION'
export const COURSES_UPLOAD_MASSIVE_PARTICIPANTS =
  'COURSES_UPLOAD_MASSIVE_PARTICIPANTS'
export const COURSES_UPLOAD_MASSIVE_PARTICIPANTS_SUCCESS =
  'COURSES_UPLOAD_MASSIVE_PARTICIPANTS_SUCCESS'

export type CoursesDownloadDisabledUsersAction = {
  type: typeof COURSES_DOWNLOAD_DISABLED_USERS
  payload: {
    loading: boolean
  }
}

export interface UploadFilePayload {
  file: File
}

export interface CoursesIndividualDownloadPayload {
  courseId: number
  filters?: IndividualFilters
  withVersions?: boolean
  onlyGeneralInfo?: boolean
}

export type CoursesIndividualDownloadAction = ActionWithPayload<
  typeof COURSES_INDIVIDUAL_DOWNLOAD,
  CoursesIndividualDownloadPayload
>

export type GetCoursePayload = number

export type GetCourseAndCreateEnrol = ActionWithPayload<
  typeof GET_COURSE_AND_CREATE_ENROL,
  GetCoursePayload
>

export const Actions = {
  coursesAdministrationListSuccess: (
    data: ICourseModel[],
    total: number,
    perPage: number,
    sort: any[]
  ) =>
    createAction(COURSES_ADMINISTRATION_GET_LIST_SUCCESS, {
      data,
      total,
      perPage,
      sort,
    }),
  createCourse: (data: ICourseModel) => createAction(CREATE_COURSE, data),
  editCourse: (data: ICourseModel) => createAction(EDIT_COURSE_SUCCESS, data),
  publishCourse: (data: ICourseModel) => createAction(PUBLISH_COURSE, data),
  destroyCourse: (courseId: number) => createAction(DESTROY_COURSE, courseId),
  getCourseSuccess: (data: ICourseModel) =>
    createAction(GET_COURSE_SUCCESS, data),
  setCourseLoading: (loading: boolean) =>
    createAction(SET_COURSE_LOADING, loading),
  getCourse: (courseId: number) => createAction(GET_COURSE, courseId),
  getCourseAndCreateEnrol: (courseId: GetCoursePayload) =>
    createAction(GET_COURSE_AND_CREATE_ENROL, courseId),
  coursesUserAllListSuccess: (data: any) =>
    createAction(COURSES_USER_GET_ALL_LIST_SUCCESS, data),
  coursesUserMyListSuccess: (data: ICourseModel[]) =>
    createAction(COURSES_USER_GET_MY_LIST_SUCCESS, data),
  coursesIndividualDownload: (data: CoursesIndividualDownloadPayload) =>
    createAction(COURSES_INDIVIDUAL_DOWNLOAD, data),
  coursesBasicReportDownload: (data: CoursesIndividualDownloadPayload) =>
    createAction(COURSES_BASIC_REPORT_DOWNLOAD, data),
  coursesUserMandatoryListSuccess: (data: ICourseModel[]) =>
    createAction(COURSES_USER_GET_MANDATORY_LIST_SUCCESS, data),
  courseAdministrationGetList: (data: any) =>
    createAction(COURSES_ADMINISTRATION_GET_LIST, data),
  coursesUserCourseProgressSuccess: (data: IAssignedLessonModel[]) =>
    createAction(COURSES_USER_COURSE_PROGRESS_SUCCESS, data),
  courseReloadCourseProgress: (data: IAssignedLessonModel[]) =>
    createAction(COURSES_USER_COURSE_PROGRESS, data),
  coursesDownloadEvaluationsSuccess: (data: string) =>
    createAction(COURSES_DOWNLOAD_EVALUATIONS_SUCCESS, data),
  coursesDownloadSuccess: (data: string) =>
    createAction(COURSES_DOWNLOAD_SUCCESS, data),
  updateCoursesDownloadDisabledUsers: (
    data: CoursesDownloadDisabledUsersAction['payload']
  ) => createAction(COURSES_DOWNLOAD_DISABLED_USERS_UPDATE, data),
  reportCourses: () => createAction(COURSES_REPORT),
  reportCoursesSuccess: (data: any) =>
    createAction(COURSES_REPORT_SUCCESS, data),
  getCourseDateToDuplicate: (courseId: number) =>
    createAction(GET_COURSE_DATA_TO_DUPLICATE, courseId),
  getCourseDateToDuplicateSuccess: (data: any) =>
    createAction(GET_COURSE_DATA_TO_DUPLICATE_SUCCESS, data),
  courseDuplicate: (data: any) => createAction(COURSE_DUPLICATE, data),
  getAdminCourse: (courseId: number) =>
    createAction(GET_ADMIN_COURSE, courseId),
  coursesIndividualDownloadSuccess: (courseId: number) =>
    createAction(COURSES_INDIVIDUAL_DOWNLOAD_SUCCESS, courseId),
  coursesGetNameList: () => createAction(COURSES_GET_NAME_LIST),
  coursesGetNameListSuccess: (data: any) =>
    createAction(COURSES_GET_NAME_LIST_SUCCESS, data),
  coursesGetCounters: () => createAction(COURSES_GET_COUNTERS),
  coursesGetCountersSuccess: (counters: any) =>
    createAction(COURSES_GET_COUNTERS_SUCCESS, counters),
  coursesGetMyFoldersSuccess: (data: IFolderModel[]) =>
    createAction(COURSES_GET_MY_FOLDERS_SUCCESS, { data }),
  coursesGetAllFoldersSuccess: (data: IFolderModel[]) =>
    createAction(COURSES_GET_ALL_FOLDERS_SUCCESS, { data }),
  coursesSetNotificationEmail: (data: ICourseModel) =>
    createAction(COURSES_SET_EMAIL_NOTIFICATION, data),
  coursesSetSection: (section: string) =>
    createAction(COURSES_SET_SECTION, section),
  uploadMassiveParticipants: ({ file }: UploadFilePayload) =>
    createAction(COURSES_UPLOAD_MASSIVE_PARTICIPANTS, { file }),
  uploadMassiveParticipantsSuccess: (data: any) =>
    createAction(COURSES_UPLOAD_MASSIVE_PARTICIPANTS_SUCCESS, data),
}

export type Actions = ActionsUnion<typeof Actions>
